import Vue from 'vue'

import template from './index.pug'

Vue.component('dynamic-input-file', {
  name: 'dynamic-input-file',
  template: template(),
  props: ['id', 'accept', 'onFileChange', 'documentNeeded', 'itemPos', 'event'],
  
  data() {
    return {
      fileName: Vue.i18n.t('dynamic-input-file.fileName'),
      hasFile: false,
    }
  },

  methods: {
    selectFile(inputId) {
      const input = document.getElementById(inputId);

      input.click();

      input.addEventListener('change', () => {
        if (input.files && input.files.length > 0) {
          const file = input.files[0];

          if (file) {
            this.fileName = file.name;
            this.hasFile = true;
          }
        }
      });
    },

    deleteFile(inputId) {
      const input = document.getElementById(inputId);

      if (input) {
        input.value = "";

        // Create an event 
        // to execute the 
        // onFileChange function
        const event = {
          type: 'change',
          target: input,
          currentTarget: input,
          preventDefault: () => {},
          stopPropagation: () => {},
        };

        this.onFileChange(event, this.documentNeeded, this.itemPos);
      }

      this.fileName = Vue.i18n.t('dynamic-input-file.fileName');
      this.hasFile = false;
    }
  }
});